/** @format */

import {Box, Button, Link, Typography} from '@mui/material';

import {styled} from '@mui/material/styles';

import {scrollbarStyles} from 'constants/scrollbar';

import {
  HEADER_HEIGHT,
  HEADER_HEIGHT_MD,
  MARGIN_BOTTOM,
  MARGIN_TOP,
  MARGIN_TOP_MD,
} from './constants';

export const BackButton = styled(Button)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(4),
  color: theme.palette.semantic_dark?.surface.onSurface,
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '20px',
  borderRadius: theme.spacing(2),
  marginBottom: theme.spacing(8),
  transition: 'background 0.2s ease',

  '&:hover': {
    background:
      'linear-gradient(0deg, rgba(131, 132, 137, 0.20) 0%, rgba(131, 132, 137, 0.20) 100%)',
  },

  '& .MuiSvgIcon-root': {
    fontSize: '20px',
  },
}));

export const AnchorLink = styled(Link)(({theme}) => ({
  display: 'block',
  marginBottom: theme.spacing(1),
  cursor: 'pointer',
  color: '#3E88C5',
}));

export const Section = styled(Box)(({theme}) => ({
  width: '100%',
  marginBottom: theme.spacing(12),
  display: 'flex',
  gap: theme.spacing(2),
}));

export const TextAndVideoBox = styled(Box)(() => ({
  width: '100%',
}));

export const AsideTitle = styled(Typography)(() => ({
  fontSize: '32px',
  fontWeight: 400,
  lineHeight: '32px',
}));

export const TwoCols = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(12),
  padding: theme.spacing(0, 3),
  marginTop: theme.spacing(MARGIN_TOP),
  height: `calc(100vh - ${theme.spacing(MARGIN_BOTTOM + MARGIN_TOP + HEADER_HEIGHT)})`,
  overflowY: 'auto',
  ...scrollbarStyles(theme, 'dark'),

  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(MARGIN_TOP_MD),
    height: `calc(100vh - ${theme.spacing(MARGIN_BOTTOM + MARGIN_TOP_MD + HEADER_HEIGHT_MD)})`,
  },

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
  },
}));

export const Sidebar = styled(Box)(({theme}) => ({
  minWidth: '300px',
  maxWidth: '420px',
  position: 'sticky',
  top: 0,

  [theme.breakpoints.down('lg')]: {
    position: 'static',
  },
}));

export const Title = styled(Typography)(({theme}) => ({
  fontSize: '24px',
  fontWeight: 400,
  color: 'white',
  marginBottom: theme.spacing(4),
}));

export const SubTitle = styled(Typography)(({theme}) => ({
  fontSize: '16px',
  fontWeight: 400,
  color: 'white',
  marginBottom: theme.spacing(2),
}));

export const Text = styled(Box)(({theme}) => ({
  maxWidth: '500px',
  marginBottom: theme.spacing(4),
}));

export const Content = styled(Box)(() => ({
  width: '100%',
  maxWidth: '924px',
}));

interface VideoPlayerWrapProps {
  height: number;
}

export const VideoPlayerWrap = styled(Box, {
  shouldForwardProp: prop => prop !== 'height',
})<VideoPlayerWrapProps>(({height}) => ({
  height: `${height}px`,
}));
